export default __webpack_public_path__ + "static/media/smiling-face-with-smiling-eyes.36935d9a.svg";